import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

import { DprCard, DprCards } from '@dpr/models';
import { DprApprover, DprDetails, DprOnlineApproval } from '@shared/models/dpr';

export abstract class DprBasePersistenceService {
  abstract getDprCards(filters: HttpParams): Observable<DprCards>;

  abstract lockDpr(
    dprDetailId: number | string,
    subprojectId: number,
    lockDate: string
  ): Observable<DprDetails>;

  abstract unlockDpr(dprDetailId: number | string): Observable<number | string>;

  abstract createDpr(subprojectId: number, date: Date): Observable<DprCard>;

  abstract createDprApprover(
    model: DprApprover,
    subprojectId: number
  ): Observable<DprApprover>;

  abstract updateDprApprover(
    model: DprApprover,
    subprojectId: number
  ): Observable<DprApprover>;

  abstract deleteDprApprover(
    dprApproverId: number | string,
    subprojectId: number,
    dprDetailId: number | string
  ): Observable<void>;

  abstract syncDprOnlineApproval(
    dprOnlineApproval: DprOnlineApproval,
    subprojectId: number
  ): Observable<{
    dprOnlineApproval: DprOnlineApproval;
    dprDetail: DprDetails;
  }>;
}
